import { useTranslation } from 'next-i18next';
import { Title } from '@restworld/ui-ds';

import EmployerCompanyList from './employer-company-list';
import EmployerCompanyListModal from './modals/employer-company-list-modal';
import EmployerCompanyActionModal from './modals/employer-company-action-modal';
import { SectionHeader, SectionWrapper } from './employer-companies.styled';

function EmployerCompanies() {
  const { t } = useTranslation('payment-and-invoices');

  return (
    <SectionWrapper>
      <SectionHeader>
        <Title fontSize="large" fontWeight="semibold" textColor="neutral-700">
          {t('billing_and_payment_method')}
        </Title>
      </SectionHeader>
      <EmployerCompanyList context="employer-payments-and-invoices" />
      <EmployerCompanyListModal />
      <EmployerCompanyActionModal />
    </SectionWrapper>
  );
}

export default EmployerCompanies;
